/*
 * /referrals — the CANONICAL referral page (the order confirmation email's
 * "Share from your phone on my.trumin" button links to
 * {MY_TRUMIN_BASE_URL}/referrals). Sign-in gated like every shell route:
 * signed out, Login renders at this path and its returnTo brings the person
 * back here. VITE_REFERRALS_ENABLED off ⇒ App redirects to the home page.
 * Optional ?event=<eventId> scrolls to and highlights that event's card.
 */
import { useSearchParams } from 'react-router-dom'
import { useLocale } from '../i18n/useLocale'
import { useReferralCodes } from '../data/referralCodes'
import { ReferralCodesSection } from '../components/ReferralCodes'

export function Referrals() {
  const { t } = useLocale()
  const [params] = useSearchParams()
  const eventParam = params.get('event')
  const highlight = eventParam && /^[A-Za-z0-9-]{1,64}$/.test(eventParam) ? eventParam : null
  const { loaded, view } = useReferralCodes()
  const empty = loaded && (!view || (view.available && view.codes.length === 0))
  return (
    <div id="referrals.root" data-testid="referrals-page">
      <h1 style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 18px' }}>{t('referral.page.title')}</h1>
      {!loaded && <div data-testid="referrals-loading" style={{ fontSize: 13, color: 'var(--text-muted)' }}>{t('referral.page.loading')}</div>}
      {empty && <div data-testid="referrals-empty" style={{ fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.5 }}>{t('referral.page.empty')}</div>}
      <ReferralCodesSection view={view} highlightEventId={highlight} />
    </div>
  )
}
